import { Link } from "react-router-dom";
import { ArrowRight, Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

const ACCENT_BG = {
  water: "bg-water-soft",
  jasmin: "bg-jasmin",
  mandariini: "bg-mandariini",
};

export default function ProductCard({ product, large = false }) {
  const { add } = useCart();

  const quickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    add(product.slug, 1);
    toast.success(`${product.name} lisätty ostoskoriin`);
  };

  return (
    <article
      data-testid={`product-card-${product.slug}`}
      className="group relative flex flex-col overflow-hidden rounded-3xl bg-white shadow-[0_10px_40px_-18px_rgba(23,68,94,0.25)] transition-transform duration-300 hover:-translate-y-1.5"
    >
      <Link
        to={`/tuote/${product.slug}/`}
        className={`relative block overflow-hidden ${ACCENT_BG[product.accent] || "bg-water-soft"}`}
        data-testid={`product-card-link-${product.slug}`}
      >
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] ${
            large ? "aspect-[4/5]" : "aspect-[4/5]"
          }`}
        />
        {product.savePercent && (
          <span
            className="absolute left-4 top-4 rounded-full bg-primary px-3.5 py-1.5 text-xs font-extrabold text-primary-foreground shadow-md"
            data-testid={`product-save-${product.slug}`}
          >
            −{product.savePercent} %
          </span>
        )}
      </Link>

      <div className="flex flex-1 flex-col p-6 md:p-7">
        <h3 className="font-heading text-xl md:text-2xl font-semibold leading-snug text-foreground" lang="fi" style={{ hyphens: "auto", overflowWrap: "break-word" }}>
          <Link to={`/tuote/${product.slug}/`} className="transition-colors hover:text-primary">
            {product.name}
          </Link>
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{product.short}</p>

        <div className="mt-auto flex items-center justify-between gap-3 pt-6">
          <div>
            <p className="text-lg font-extrabold text-foreground" data-testid={`product-price-${product.slug}`}>
              {product.priceLabel}
            </p>
            <p className="text-xs text-muted-foreground">
              {product.compareAtLabel ? (
                <span className="line-through">{product.compareAtLabel}</span>
              ) : (
                "sis. ALV"
              )}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={quickAdd}
              data-product-slug={product.slug}
              data-testid={`quick-add-${product.slug}`}
              aria-label={`Lisää ${product.name} ostoskoriin`}
              className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-secondary text-secondary-foreground transition-all duration-200 hover:bg-primary hover:text-primary-foreground"
            >
              <Plus size={18} strokeWidth={2.5} />
            </button>
            <Link
              to={`/tuote/${product.slug}/`}
              data-testid={`product-view-${product.slug}`}
              className="inline-flex h-11 items-center gap-2 rounded-full bg-primary px-5 text-sm font-bold text-primary-foreground transition-transform duration-200 hover:scale-[1.03]"
            >
              Katso tuote <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
